import { Injectable } from '@angular/core';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseStatusEnum } from '../enumerators/enumerators.enum';
import { AlertEnum } from '../enumerators/messages.enum';
import { MessageService } from '../services/message.service';

@Injectable()
export class HttpErrorHandlingInterceptor implements HttpInterceptor {

    constructor(private mensajeService: MessageService, private translateService: TranslateService) { }

    /**
     * The intercept function checks if the user is online, displays an error message if not, and
     * handles the HTTP response status and message.
     * @param request - The `request` parameter is an instance of the `HttpRequest` class, which
     * represents an HTTP request made by the client.
     * @param {HttpHandler} next - The `next` parameter is an instance of the `HttpHandler` class. It
     * represents the next handler in the chain of handlers that will be called to process the request.
     * @returns an Observable of type HttpEvent<any>.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!window.navigator.onLine) {
            this.mensajeService.alert(AlertEnum.Error, this.translateService.instant('ErrorConexionInternet'));
            return throwError(this.translateService.instant('ErrorConexionInternet'));
        }
        return next.handle(request).pipe(

            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    var response = this.handlingHttpStatus(event.status, event.body?.message);
                    if (response) { this.mensajeService.alert(response.alerta, response.message) };
                }

                return event;
            }));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0 && error.error instanceof ProgressEvent) {
            // A client-side or network error occurred. Handle it accordingly.
        }
    };

   /**
    * The function handles different HTTP status codes and returns an object with an alert type and a
    * corresponding message.
    * @param {number} status - The `status` parameter is a number that represents the HTTP status code
    * of a response. It is used to determine the appropriate action or message to be returned based on
    * the status code.
    * @param {string} message - The `message` parameter is a string that represents an optional custom
    * message to be displayed along with the status code.
    * @returns an object with two properties: "alerta" and "message". The values of these properties
    * depend on the input status parameter. If the status matches one of the predefined constants (e.g.
    * ResponseStatusType.NO_CONTENT), then the corresponding alert type and message are returned. If
    * the status does not match any of the predefined constants, null is returned.
    */
    handlingHttpStatus(status: number, message: string) {
        switch (status) {
            case ResponseStatusEnum.NO_CONTENT:
                return { alerta: AlertEnum.Information, message: this.translateService.instant('ResponseStatus.NO_CONTENT') }
            case ResponseStatusEnum.PARTIAL_CONTENT:
                return { alerta: AlertEnum.Warning, message: message ? message : this.translateService.instant('ResponseStatus.PARTIAL_CONTENT') }
            case ResponseStatusEnum.BAD_REQUEST:
                return { alerta: AlertEnum.Error, message: message ? message : this.translateService.instant('ResponseStatus.BAD_REQUEST') }
            case ResponseStatusEnum.UNAUTHORIZED:
                return { alerta: AlertEnum.Warning, message: this.translateService.instant('ResponseStatus.UNAUTHORIZED') }
            case ResponseStatusEnum.PARTIAL_CONTENT:
                return { alerta: AlertEnum.Information, message: this.translateService.instant('ResponseStatus.NOT_FOUND') }
            case ResponseStatusEnum.INTERNAL_SERVER_ERROR:
                return { alerta: AlertEnum.Error, message: this.translateService.instant('ResponseStatus.INTERNAL_SERVER_ERROR') }
            default:
                return null
        }
    }
}
